import { JournalEntry } from '@/hooks/emotion-detector';

export function formatEntryDate(entry: JournalEntry): string {
	try {
		const dateString = entry.created_at || entry.createdAt;
		if (dateString) {
			const date = new Date(dateString);
			if (!isNaN(date.getTime())) {
				return date.toLocaleString();
			}
		}
	} catch {
		// Date parsing failed
	}
	return 'Invalid Date';
}

export function getImageUrl(image: { url?: string; signed_url?: string }): string | null {
	return image.signed_url || image.url || null;
}

export function getNoteKey(entryId: string): string {
	return `note-${entryId}`;
}
